var map = {
	"./admin_management.svg": 5148,
	"./brush.svg": 5915,
	"./caidan.svg": 7939,
	"./drink.svg": 429,
	"./e-commerce.svg": 8758,
	"./evaluate.svg": 6612,
	"./food.svg": 8249,
	"./function.svg": 2737,
	"./gongnengquanxian.svg": 7731,
	"./home.svg": 7123,
	"./hotel.svg": 4273,
	"./hotel_data.svg": 5196,
	"./hotel_management.svg": 7245,
	"./invoice.svg": 3414,
	"./jingdong.svg": 4145,
	"./jingdong1.svg": 2674,
	"./laundry.svg": 8984,
	"./mall.svg": 6475,
	"./meituan.svg": 6916,
	"./peoples.svg": 6779,
	"./picture.svg": 8201,
	"./pinduoduo.svg": 6766,
	"./qr_code.svg": 1008,
	"./quanping.svg": 8278,
	"./quxiaoquanping_o.svg": 9155,
	"./room.svg": 9940,
	"./rukou.svg": 6041,
	"./security.svg": 9903,
	"./serve.svg": 4513,
	"./ticket.svg": 5401,
	"./tools.svg": 7622,
	"./user-settings.svg": 710,
	"./withdraw_management.svg": 2627,
	"./ze-orders.svg": 3932,
	"./zhifufangshi.svg": 6245
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2922;